(function () {
  if (window.__lgManagedRatingsLoaded) return;
  window.__lgManagedRatingsLoaded = true;

  var apiBase = window.lgApiBase || "https://lab.lostgear.xyz";
  var cache = {};

  function getDecimal(rating) {
    var decimal = Number(rating || 0) % 1;
    if (decimal >= 0.3 && decimal <= 0.7) return 0.5;
    if (decimal > 0.7) return 1;
    return 0;
  }

  function renderCompact(node, average, count) {
    if (count <= 0 || average <= 0) {
      node.innerHTML = '<span class="lg-product-rating__none">No reviews yet</span>';
      return;
    }

    var rounded = Math.round(average);
    var html = '<div class="lg-product-rating__stars">';
    for (var i = 1; i <= 5; i++) {
      var fill = i <= rounded ? "var(--lg-orange)" : "var(--lg-line-dark)";
      html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="' + fill + '" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
    }
    html += "</div>";
    html += '<span class="lg-product-rating__score">' + average.toFixed(1) + "</span>";
    html += '<span class="lg-product-rating__count">(' + count + ")</span>";
    node.innerHTML = html;
  }

  function renderDetailed(node, average, count) {
    if (count <= 0 || average <= 0) {
      node.hidden = true;
      node.innerHTML = "";
      return;
    }

    var decimal = getDecimal(average);
    node.hidden = false;
    node.innerHTML =
      '<div class="rating" role="img" aria-label="' + average.toFixed(1) + ' out of 5 stars based on ' + count + ' reviews">'
      + '<span aria-hidden="true" class="rating-star" style="--rating: ' + Math.floor(average) + "; --rating-max: 5; --rating-decimal: " + decimal + ';"></span>'
      + "</div>"
      + '<p class="rating-text caption"><span aria-hidden="true">' + average.toFixed(1) + " / 5</span></p>"
      + '<p class="rating-count caption"><span aria-hidden="true">(' + count + ')</span><span class="visually-hidden">' + count + " total reviews</span></p>";
  }

  function fetchSummary(handle) {
    if (!handle) return Promise.resolve({ average: 0, count: 0 });
    if (!cache[handle]) {
      cache[handle] = fetch(apiBase + "/api/storefront-reviews?product_handle=" + encodeURIComponent(handle) + "&limit=1")
        .then(function (response) {
          if (!response.ok) throw new Error("Failed to load reviews");
          return response.json();
        })
        .then(function (data) {
          return {
            average: Number(data && data.average) || 0,
            count: Number(data && data.count) || 0,
          };
        })
        .catch(function () {
          return { average: 0, count: 0 };
        });
    }
    return cache[handle];
  }

  function updateNode(node) {
    if (!node || node.dataset.lgManagedRatingReady === "true") return;

    var handle = node.getAttribute("data-product-handle");
    var style = node.getAttribute("data-rating-style") || "detailed";

    if (!handle) return;

    node.dataset.lgManagedRatingReady = "true";

    fetchSummary(handle).then(function (summary) {
      if (style === "compact") {
        renderCompact(node, summary.average, summary.count);
        return;
      }

      renderDetailed(node, summary.average, summary.count);
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll("[data-lg-managed-rating]");
    for (var i = 0; i < nodes.length; i++) {
      updateNode(nodes[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
